export const texts = {
  title: {
    de: 'Stellen',
    en: 'Positions'
  },
  newJob: {
    de: 'Neue Stelle',
    en: 'New position'
  },
  searchPlaceholder: {
    de: 'Suchen',
    en: 'Search'
  },
  statusPrefix: {
    de: 'Status:',
    en: 'Status:'
  },
  typePrefix: {
    de: 'Typ:',
    en: 'Type:'
  },
  typeNames: {
    All: { de: 'Alle', en: 'All' },
    Full: { de: 'Direktansprache', en: 'Direct outreach' },
    Longlist: { de: 'Longlist', en: 'Longlist' }
  },
  statusNames: {
    All: { de: 'Alle', en: 'All' },
    Imported: { de: 'Importiert', en: 'Imported' },
    AnalysisRequested: { de: 'Analyse', en: 'Analysis' },
    AwaitingOrder: { de: 'Vorbereitet', en: 'Prepared' },
    AwaitingSourcing: { de: 'In Bearbeitung', en: 'In progress' },
    Sourcing: { de: 'In Bearbeitung', en: 'In progress' },
    Completed: { de: 'Abgeschlossen', en: 'Completed' },
    Paused: { de: 'Pausiert', en: 'Paused' },
    Cancelled: { de: 'Abgebrochen', en: 'Cancelled' }
  },
  ownershipNames: {
    Self: { de: 'Nur meine', en: 'Only mine' },
    Others: { de: 'Nur andere', en: 'Only others' },
    All: { de: 'Alle', en: 'All' }
  },
  loading: {
    de: 'Lade Stellen...',
    en: 'Loading positions...'
  },
  empty: {
    de: 'Keine Stellen',
    en: 'No positions'
  },
  loadMore: {
    de: 'Weitere laden',
    en: 'Load more'
  }
};
